import {EComparisonType} from 'components/form/hooks/use-form-watcher/use-form-watcher-constants';

export const requiredInputRule = (message:string = 'Обязательное поле') => (
    {required: true, message}
);

export const fourDigitRule = (message = 'Введите 4 цифры') => ({
    validator: (_:any, value:string) =>
        /^\d{4}$/.test(value)
            ? Promise.resolve()
            : Promise.reject(message)
});

interface INumberWithDotValidator {
    valueBefore: number;
    valueAfter: number;
}

export const numberWithDotRule = ({
    valueBefore,
    valueAfter,
}:INumberWithDotValidator) => (
    {
        validator: (_:any, value:string) => {
            const regexPattern = `^\\d{1,${valueBefore}}(\\.\\d{1,${valueAfter}})?$`;

            const regex = new RegExp(regexPattern);
            if (value && !regex.test(value)) {
                return Promise.reject(
                    new Error(`Допускается не более ${valueBefore} знаков до запятой и ${valueAfter} после запятой`)
                );
            }
            return Promise.resolve();
        },
    }
);

interface ILengthValidationRule {
    comparisonOperator: EComparisonType;
    value: number;
}

export const lengthValidationRule = ({
    comparisonOperator,
    value,
}:ILengthValidationRule) => {
    switch (comparisonOperator) {
        case EComparisonType.LESS:
            return {max: value, message: `Длина должна быть не более ${value} символов`};
        case EComparisonType.GREATER:
            return {min: value, message: `Длина должна быть не менее ${value} ${value === 1 ? 'символа' : 'символов'}`};
        default:
            return {};
    }
}

export const numberLengthValidationRule = (options: ILengthValidationRule) => ({
    validator: (_: any, value: unknown) => {
        const strValue = String(value ?? '');
        const rule = lengthValidationRule(options);

        if (rule.min !== undefined && strValue.length < rule.min) {
            return Promise.reject(rule.message);
        }
        if (rule.max !== undefined && strValue.length > rule.max) {
            return Promise.reject(rule.message);
        }
        return Promise.resolve();
    },
});
